@if (university(); as university) {
	@if (!isLoading() && course(); as course) {
		<uc-university-header
			*ucRemoveDuplicateDomElement="'hideOnMobile'"
			[logo]="university.logo"
			[uniName]="university.name"
			[saved]="course.saved"
			[id]="course.id"
			[delta]="2"
			[courseSlug]="course.slug"
			[ugSearchOrderPosition]="null"
			[cleSearchOrderPosition]="university.order"
			[academicYear]="course.academic_year"
			product="clearing"
		>
			<uc-header-title
				headerTitle
				[courseName]="course.name"
				[uniName]="university.name"
				[uniSlug]="uniSlug()"
				[uniId]="university.id"
				[searchOrderPosition]="university.order"
				[product]="product"
			/>
		</uc-university-header>
		<div class="relative">
			@if (isFeaturedClearing()) {
				<uc-clearing-available-badge
					[currentClearingYear]="currentClearingYear"
				/>
			}
			@if (uniGallery()) {
				<uc-university-slider
					[uniGallery]="uniGallery()!"
					[product]="product"
					[isFeaturedGallery]="isFeaturedClearing()"
					[uniSliderCopy]="uniSliderCopy"
					[id]="course.id"
					[saved]="course.saved"
					[delta]="2"
					[courseSlug]="course.slug"
					[uniName]="university.name"
					[ugSearchOrderPosition]="null"
					[cleSearchOrderPosition]="university.order"
					[academicYear]="course.academic_year"
				>
					<uc-header-title
						headerTitle
						[courseName]="course.name"
						[uniName]="university.name"
						[uniSlug]="uniSlug()"
						[product]="product"
						[uniId]="university.id"
						[searchOrderPosition]="university.order"
					/>
					<uc-cta-clearing
						[isFeaturedClearingVisitWebsite]="
							isFeaturedClearingVisitWebsite()
						"
						[isFeaturedRegisterInterest]="isFeaturedRegisterInterest()"
						[isFeaturedCalls]="isFeaturedCalls()"
						[uniId]="university.id!"
						[externalUrl]="course.university.external_url"
						[uniName]="university.name"
						[uniId]="university.id"
						[phoneNumber]="course.university.phone_number ?? ''"
						sourceType="course"
						[source]="course.name"
						componentName="Profile Header"
						[cleSearchOrderPosition]="university.order"
						[privacyPolicyUrl]="university.privacy_policy_url"
					/>
				</uc-university-slider>
			}
		</div>
		<!-- Course Headings -->
		@if (course) {
			<uc-clearing-course-headings
				[courseSummary]="course.overview"
				[courseName]="course.name"
				[isFeatured]="isFeaturedClearingVisitWebsite()"
				[uniId]="university.id!"
				[uniName]="university.name"
				[externalUrl]="university.external_url"
				[clearingUsp]="university.usp.text"
				[clearingCourseEnabled]="clearingCourseEnabled"
				[cleSearchOrderPosition]="university.order"
				[privacyPolicyUrl]="university.privacy_policy_url"
			/>
		}
		<!-- Course Information -->
		@if (
			course && course.options && course.options[selectedIndex()];
			as selectedOption
		) {
			@if (course.options) {
				<uc-course-information
					[isFeatured]="isFeaturedClearing()"
					class="md:col-span-2"
					[courseOptions]="course.options"
					[selectedIndex]="selectedIndex()"
					[clearingCourseEnabled]="clearingCourseEnabled"
					(selectIndex)="onCourseOptionSelect($event)"
				>
					@if (isFeaturedRegisterInterest() || isFeaturedCalls()) {
						<div class="flex gap-3 mt-6">
							@if (isFeaturedRegisterInterest()) {
								<uc-register-interest-btn
									class="w-full"
									customStyles="w-full"
									sourceType="course"
									[uniId]="university.id"
									componentName="Course Information"
									[cleSearchOrderPosition]="university.order"
									data-cy="course-information-register-interest-btn"
								/>
							}
							@if (isFeaturedCalls() && course.university.phone_number) {
								<uc-call-uni-btn
									class="w-full"
									customStyles="w-full"
									[phoneNumber]="course.university.phone_number"
									buttonText="Call University"
									mobileButtonText="Call University"
									sourceType="course"
									[uniId]="university.id"
									[uniName]="university.name"
									[source]="course.name"
									componentName="Course Information"
									[cleSearchOrderPosition]="university.order"
									data-cy="course-information-call-uni-btn"
								/>
							}
						</div>
					}
				</uc-course-information>
			}
			<!-- Application Details -->
			<uc-course-profile-application-details
				[isFeatured]="isFeaturedClearingVisitWebsite()"
				[externalUrl]="university.external_url"
				[courseCode]="course.code"
				[institutionCode]="course.institution_code"
				[entryPoints]="selectedOption.entry_years"
				[applicationDeadline]="selectedOption.application_deadline"
				[uniId]="university.id!"
				[uniName]="university.name"
				[product]="product"
				[clearingCourseEnabled]="clearingCourseEnabled"
				[currentClearingYear]="currentClearingYear"
				[courseName]="course.name"
				[searchOrder]="-1"
				[privacyPolicyUrl]="university.privacy_policy_url"
			/>
			<!-- Entry requirements -->
			@if (
				selectedOption.entry_requirements &&
				selectedOption.entry_requirements.length >= 1
			) {
				<uc-entry-requirements
					[externalUrl]="university.external_url"
					[entryRequirements]="selectedOption.entry_requirements"
					[isFeatured]="isFeaturedClearingVisitWebsite()"
				>
					<ng-template #visitWebsiteBtn>
						<uc-clearing-visit-website-btn
							visitWebsiteBtn
							[externalUrl]="university.external_url"
							customStyles="w-full sm:w-auto"
							componentName="Entry Requirements"
							[uniId]="university.id"
							[uniName]="university.name"
							buttonText="Find Out More"
							sourceType="course"
							[source]="course.name"
							[cleSearchOrderPosition]="university.order"
							[privacyPolicyUrl]="university.privacy_policy_url"
						/>
					</ng-template>
				</uc-entry-requirements>
			}
			@if (university) {
				<uc-course-search-banner
					[product]="product"
					[uniName]="university.name!"
					[uniSlug]="university.slug!"
					description="Fancy a new challenge? Find the perfect course for you with our Clearing course search."
				/>
			}
			<!-- Call this university CTA - Clearing-->
			@if (isFeaturedCalls() && course.university.phone_number) {
				<div class="container">
					<uc-engage-card-cta-call-uni
						[uniId]="university.id"
						[uniName]="university.name"
						[phoneNumber]="course.university.phone_number"
						[source]="course.name"
						sourceType="course"
						[cleSearchOrderPosition]="university.order"
					/>
				</div>
			}
			<!-- Fees an Funding -->
			@if (
				selectedOption && selectedOption.fees && selectedOption.fees.length >= 1
			) {
				<uc-fees-and-funding
					[fees]="selectedOption.fees"
					[externalUrl]="
						course.university.external_scholarships_url ??
						selectedOption.external_url
					"
					[isFeatured]="isFeaturedClearing()"
				>
					<ng-template #visitWebsiteBtnFeesFunding>
						<uc-clearing-visit-website-btn
							[externalUrl]="university.external_url"
							customStyles="w-full sm:w-auto"
							componentName="Fees and Funding"
							[uniId]="university.id"
							buttonText="Find Out More"
							sourceType="course"
							[source]="course.name"
							[cleSearchOrderPosition]="university.order"
							[uniName]="university.name"
							[privacyPolicyUrl]="university.privacy_policy_url"
							data-cy="clearing-fees-funding-visit-website-btn"
						/>
					</ng-template>
				</uc-fees-and-funding>
			}
			<!-- If no data for fees and funding -->
			@if (selectedOption.fees?.length === 0) {
				<uc-no-fees-and-funding [courseName]="course.name">
					<uc-clearing-visit-website-btn
						[externalUrl]="university.external_url"
						customStyles="!font-bold !text-gray-800 !underline !border-0 !bg-transparent !p-0"
						componentName="Fees and Funding"
						[uniId]="university.id"
						buttonText="Click here"
						sourceType="course"
						[source]="course.name"
						[cleSearchOrderPosition]="university.order"
						[uniName]="university.name"
						[privacyPolicyUrl]="university.privacy_policy_url"
						data-cy="clearing-no-fees-funding-visit-website-btn"
					/>
				</uc-no-fees-and-funding>
			}
			<!-- Register your interest- clearing-->
			@if (isFeaturedRegisterInterest()) {
				<div class="container">
					<uc-engage-card-register-interest-cta
						[uniId]="university.id!"
						sourceType="course"
						[cleSearchOrderPosition]="university.order"
					/>
				</div>
			}
			<!-- Clearing Footer -->
			<uc-clearing-cta-final
				[uniId]="university.id"
				[uniName]="university.name"
				[isFeaturedCalls]="isFeaturedCalls()"
				[isFeaturedRegisterInterest]="isFeaturedRegisterInterest()"
				[isFeaturedClearingVisitWebsite]="isFeaturedClearingVisitWebsite()"
				[phoneNumber]="course.university.phone_number ?? ''"
				[externalUrl]="course.university.external_url"
				[currentClearingYear]="currentClearingYear"
				[source]="course.name"
				[cleSearchOrderPosition]="university.order"
				[privacyPolicyUrl]="university.privacy_policy_url"
			/>
			<!-- On desktop -> show university buttons at the bottom-->
			@if (isFeaturedClearing()) {
				<uc-client-profile-sticky-lead-bar-desktop
					[uniId]="university.id"
					[uniName]="university.name"
					[product]="product"
					[paidFeatures]="university.paid_features!"
					[externalUrl]="externalUrl()"
					[phoneNumber]="course.university.phone_number ?? ''"
					[showClearing]="true"
					[source]="course.name"
					sourceType="course"
					[ugSearchOrderPosition]="null"
					[cleSearchOrderPosition]="university.order"
					[privacyPolicyUrl]="university.privacy_policy_url ?? ''"
				/>
				<uc-client-profile-sticky-lead-bar-mobile
					[isFeatured]="isFeaturedClearing()"
				>
					<uc-clearing-visit-website-btn
						customStyles="w-full"
						[externalUrl]="externalUrl()"
						componentName="Sticky Lead Bar"
						[uniId]="university.id"
						[source]="course.name"
						sourceType="course"
						[uniName]="university.name"
						[cleSearchOrderPosition]="university.order"
						[privacyPolicyUrl]="university.privacy_policy_url"
						data-cy="mobile-sticky-lead-bar-visit-website-btn"
					/>
				</uc-client-profile-sticky-lead-bar-mobile>
			}
		}
	}
}
@if (isLoading()) {
	<uc-course-skeleton />
}
